// extracted by mini-css-extract-plugin
module.exports = {"loom-preview":"LoomPreview_loom-preview___2l9f","loom-preview__iframe":"LoomPreview_loom-preview__iframe__3de96"};